import * as React from 'react';
import styled from 'styled-components';
import { __, __r } from 'react-i18n';
import { withRouter, WithRouterProps } from 'react-router';
import { rem } from 'polished';
import { TextP } from '../../../Defaults/Text';
import { Loader } from '../../../Defaults/Loader';
import { ErrorAlert } from '../../../Defaults/Alerts/ErrorAlert';
import { StyledTitle } from '../../ProductDetail/Description';
import { DsiCheckBox } from '../../General/Checkbox';

const Wrapper = styled.div`
  width: 100%;
  max-width: ${rem(320)};
  padding: 0;
  border-radius: ${rem(4)};

  ${({ theme }) => theme.mediab.l925`
   padding-top: ${rem(24)};
  `}
`;

interface UserSettingsBlockPropsIO {
  onNewsletterChange: any;
  customerInfo: any;
}

interface State {
  fetching: boolean;
  newsletterAccept: boolean;
}

export class UserSettingsBlock extends React.Component<
  UserSettingsBlockPropsIO,
  State
> {
  constructor(props) {
    super(props);

    this.state = {
      fetching: false,
      newsletterAccept: this.props.customerInfo?.newsletter_accept,
    };
  }

  public componentDidUpdate(prevProps: UserSettingsBlockPropsIO) {
    if (
      prevProps.customerInfo?.newsletter_accept !==
      this.props.customerInfo?.newsletter_accept
    ) {
      this.setState({
        newsletterAccept: this.props.customerInfo?.newsletter_accept || false,
      });
    }
  }

  public async onNewsletterAcceptChange() {
    try {
      this.setState({ fetching: true });
      await this.props?.onNewsletterChange(!this.state.newsletterAccept);
      this.setState({
        newsletterAccept: !this.state.newsletterAccept,
        fetching: false,
      });
    } catch (e) {
      this.setState({ fetching: false });
    }
  }

  public render() {
    const { fetching, newsletterAccept } = this.state;
    return (
      <Loader loading={fetching}>
        <Wrapper>
          <StyledTitle>{__('Užívateľské nastavenia')}</StyledTitle>
          <DsiCheckBox
            name="newsletter_accept"
            onClick={() => this.onNewsletterAcceptChange()}
            label={__('Súhlasím so začlenením do newslettera')}
            selected={newsletterAccept}
            wrapperStyle={{ marginBottom: rem(16) }}
          />
        </Wrapper>
      </Loader>
    );
  }
}
